export enum AuthenticationType {
    BUILTIN = "builtin",
    SAML = "saml",
}

export interface NetworkUserLoginQueryIDPsResponse {
    entries: string[];
    samlIdentifier?: string;
}
